<div class="footer-wrapper">
  <!-- Background image -->
  <img class="footer-background" src="../../../assets/img/Footer 6 Light Mode.png" alt="Footer Background" />

  <div class="footer-card">
    <div class="row g-0">
      <!-- Column 1: Brand -->
      <div class="col-lg-4 col-md-12 mb-2 mb-lg-0 pe-lg-4">
        <div class="d-flex align-items-center mb-3">
          <img class="logo-icon me-3" src="../../../assets/img/logo.png" alt="UP CAREER Logo" />
          <span class="brand-name">UP CAREER</span>
        </div>
        <p class="brand-description d-none d-md-block">
          {{ "footer_description" | translate }}
        </p>
      </div>

      <!-- Column 2: Services -->
      <div class="col-lg-3 col-md-4 mb-2 mb-md-0 mobile-accordion">
        <h5 class="section-title d-flex justify-content-between align-items-center"
            (click)="isServicesOpen = !isServicesOpen">
          {{ "Services" | translate }}
          <svg class="d-md-none" [ngStyle]="{'transform': isServicesOpen ? 'rotate(180deg)' : 'rotate(0)', 'transition': '0.3s'}" width="14" height="8" viewBox="0 0 14 8" fill="none">
            <path d="M1 1L7 7L13 1" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </h5>

        <!-- Company Services (same as header) -->
        <ul *ngIf="isCompanyPage" class="list-unstyled footer-list" [ngClass]="{'d-none d-md-block': !isServicesOpen}">
          <li><a routerLink="/job-post" routerLinkActive="active-link">{{ "Job Post" | translate }}</a></li>
          <li><a routerLink="/virtual-interview-company" routerLinkActive="active-link">{{ "Virtual Interview" | translate }}</a></li>
          <li><a routerLink="/contact" routerLinkActive="active-link">{{ "Contact UpCareer" | translate }}</a></li>
        </ul>

        <!-- User Services -->
        <ul *ngIf="!isCompanyPage" class="list-unstyled footer-list" [ngClass]="{'d-none d-md-block': !isServicesOpen}">
          <li><a routerLink="/careerCoach" routerLinkActive="active-link">{{ "Career Coaching" | translate }}</a></li>
          <li><a routerLink="/scan-cv" routerLinkActive="active-link">{{ "Scan CV" | translate }}</a></li>
          <li><a routerLink="/generatResume" routerLinkActive="active-link">{{ "Creation CV" | translate }}</a></li>
          <li><a routerLink="/create-cover-letter" routerLinkActive="active-link">{{ "Creation Cover Letter" | translate }}</a></li>
          <li><a routerLink="/create-linkedin-profile" routerLinkActive="active-link">{{ "linkedin_optimization" | translate }}</a></li>
          <li><a routerLink="/scan-linkedin" routerLinkActive="active-link">{{ "Scan LinkedIn" | translate }}</a></li>
          <li><a routerLink="/virtual-interview" routerLinkActive="active-link">{{ "Interview" | translate }}</a></li>
        </ul>
      </div>


      <!-- Column 3: Our Company (hidden for company users) -->
      <div *ngIf="!isCompanyPage" class="col-lg-2 col-md-4 mb-2 mb-md-0 mobile-accordion">
        <h5 class="section-title d-flex justify-content-between align-items-center"
            (click)="isCompanyOpen = !isCompanyOpen">
          {{ "Our Company" | translate }}
          <svg class="d-md-none" [ngStyle]="{'transform': isCompanyOpen ? 'rotate(180deg)' : 'rotate(0)', 'transition': '0.3s'}" width="14" height="8" viewBox="0 0 14 8" fill="none">
            <path d="M1 1L7 7L13 1" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </h5>
        <ul class="list-unstyled footer-list" [ngClass]="{'d-none d-md-block': !isCompanyOpen}">
          <li><a routerLink="/job-list" routerLinkActive="active-link">{{ "Jobs" | translate }}</a></li>
          <li><a routerLink="/articles" routerLinkActive="active-link">{{ "Articles" | translate }}</a></li>
          <li><a routerLink="/about" routerLinkActive="active-link">{{ "About us" | translate }}</a></li>
          <li><a routerLink="/contact" routerLinkActive="active-link">{{ "Contact" | translate }}</a></li>
          <li><a routerLink="/FQA" routerLinkActive="active-link">{{ "FAQ" | translate }}</a></li>
          <li><a routerLink="/policy" routerLinkActive="active-link">{{ "policy" | translate }}</a></li>
        </ul>
      </div>


      <!-- Column 4: Office Location -->
      <div class="col-lg-3 col-md-4 mobile-accordion mobile-accordion-last">
        <h5 class="section-title d-flex justify-content-between align-items-center"
            (click)="isLocationOpen = !isLocationOpen">
          {{ "Office location" | translate }}
          <svg class="d-md-none" [ngStyle]="{'transform': isLocationOpen ? 'rotate(180deg)' : 'rotate(0)', 'transition': '0.3s'}" width="14" height="8" viewBox="0 0 14 8" fill="none">
            <path d="M1 1L7 7L13 1" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </h5>
        <p class="address" [ngClass]="{'d-none d-md-block': !isLocationOpen}">{{ "Shoubra, Cairo, Egypt" | translate }}</p>
      </div>
    </div>

    <!-- Bottom Row -->
    <div class="footer-bottom d-flex align-items-center flex-wrap gap-4 gap-lg-5 pt-2">
      <div class="bottom-info d-flex gap-4 gap-lg-5">
        <span class="underlined-text">2026 {{ "All rights reserved" | translate }}</span>
        <span class="underlined-text d-none d-md-block">+201555842727</span>
      </div>
      <div class="social-icons d-flex gap-4 ms-lg-4">
        <a href="https://www.linkedin.com/company/up-career/" target="_blank">
          <img src="../../../assets/icon/linkedin.svg" alt="LinkedIn" />
        </a>
        <a href="https://www.facebook.com/@upcareer.CV/?mibextid=ZbWKwL" target="_blank">
          <img src="../../../assets/icon/facebook.svg" alt="Facebook" />
        </a>
        <a href="https://x.com/upcareer2022?s=09" target="_blank">
          <img src="../../../assets/icon/twitter.svg" alt="Twitter" />
        </a>
      </div>
    </div>
  </div>
</div>